/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/recycledCottonSmall.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube005.geometry}
				material={materials["Red diamond fabric.001"]}
				position={[0.149, 0.132, 0.597]}
				rotation={[0, 1.15, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube004.geometry}
				material={materials["Plain Gold Texture.001"]}
				position={[-0.141, 0.12, 0.597]}
				rotation={[0, 0.824, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube003.geometry}
				material={materials["Plain Duckegg Texture.001"]}
				position={[-1.024, 0.072, 0.597]}
				rotation={[0, 0, 0.307]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube002.geometry}
				material={materials["Floral Natural Jacquard.001"]}
				position={[-0.436, 0.102, 0.597]}
				rotation={[0, 0.529, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube001.geometry}
				material={materials["Plain Grey Sheer.001"]}
				position={[-0.707, 0.093, 0.597]}
				rotation={[0, 0.263, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube.geometry}
				material={materials["recycle.001"]}
				position={[0.001, 0.363, -0.005]}
				scale={[1.106, 0.411, 1.106]}
			/>
		</group>
	);
}

useGLTF.preload("models/recycledCottonSmall.glb");
